import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5dd9ea1a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./treatmentCreateOrder.scss?vue&type=style&index=0&id=5dd9ea1a&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd9ea1a",
  null
  
)

export default component.exports